<template>
  <div ref="agreement" class="agreement">
    <!-- <h2 style="text-align: center">用户协议</h2> -->
    <div v-if="loading" style="text-align: center; padding: 40px">
      <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
    </div>
    <!-- 已同意协议点击查看已签署协议的内容 -->
    <div v-if="form.isAgreen" class="agreement-bd">
      <!-- 如果没有url 则说明没有截取到当时签协议的截图  则显示最新的协议内容并附上当时签署协议的时间与昵称 -->
      <!-- <img v-if="form.agreeUrl" :src="api.FileHost + form.agreeUrl" /> -->
    </div>
    <div
      v-if="form.AgreementId"
      id="agreement-bd"
      class="agreement-bd"
      style="padding-bottom: 60px"
    >
      <h1 style="font-size: 24px; text-align: center; margin: 16px 0">
        {{ form.Title }}
      </h1>
      <div style="text-align: right; padding: 0 0 10px 0">
        合同编号：____________
      </div>
      <div
        v-if="AgreementInfo.EnableIdCard"
        style="position: relative; line-height: 1.6"
      >
        <div>甲方：{{ partyA.username }}</div>
        <div>身份证号：{{ partyA.id }}</div>
        <div>联系方式：{{ partyA.phone }}</div>
        <van-button
          v-if="!partyA.id"
          class="add-parta"
          size="small"
          style="display: none"
          type="primary"
          @click="showPartAAdd"
        >
          点击实名认证
        </van-button>
      </div>
      <div
        v-if="AgreementInfo.EnableIdCard"
        style="position: relative; margin: 16px 0 36px; line-height: 1.6"
      >
        <div>乙方：{{ tenant.TenantDesc }}</div>
        <div v-if="tenant.Address">注册地址：{{ tenant.Address }}</div>
        <div v-if="tenant.LegalPerson">
          法定代表人：{{ tenant.LegalPerson }}
        </div>
        <div v-if="tenant.Telephone">联系方式：{{ tenant.Telephone }}</div>
      </div>
      <div class="ql-editor" v-html="form.content"></div>
      <table style="width: 100%; margin-top: 36px">
        <tr>
          <td style="width: 40px">甲方:</td>
          <td>
            <div>{{ partyA.username }}</div>
            <div style="word-break: break-all; font-size: 14px">
              微信UnionId:{{ userInfo && userInfo.WechatUnionId }}
            </div>
          </td>
          <td style="width: 40px">乙方:</td>
          <td style="min-width: 140px">
            <p style="text-align: left">
              {{ tenant && tenant.TenantDesc }}
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <span v-if="AgreementInfo.EnableAgreementSign">签名:</span>
          </td>
          <td>
            <div
              v-if="AgreementInfo.EnableAgreementSign"
              style="
                height: 60px;
                line-height: 60px;
                position: relative;
                text-align: left;
              "
            >
              <a
                style="
                  padding: 0 0;
                  color: #1989fa;
                  display: block;
                  cursor: pointer;
                "
                @click="show = true"
              >
                <span v-if="AgreementInfo.Sign">
                  <img
                    id="img"
                    class="sign-img"
                    :src="AgreementInfo.Sign"
                    style="width: 150px; height: 60px"
                  />
                </span>
                <span v-else>点击签名</span>
              </a>
            </div>
          </td>
          <td>
            <span v-if="AgreementInfo.EnableCorporateSeal">盖章:</span>
          </td>
          <td>
            <img
              v-if="AgreementInfo.EnableCorporateSeal"
              class="Corporate-img"
              :src="api.FileHost + AgreementInfo.CorporateSealUrl"
              style="width: 140px; height: 140px"
            />
          </td>
        </tr>
        <tr>
          <td></td>
          <td style="font-size: 15px">
            {{ time }}
          </td>
          <td></td>
          <td style="font-size: 15px">
            {{ time }}
          </td>
        </tr>
      </table>
    </div>
    <!-- <div
      v-if="!form.AgreementId && !loading"
      class="bd"
      style="text-align: center"
    >
      <h4>该产品暂未设置协议</h4>
    </div> -->
    <div v-if="form.AgreementId" class="btn-box" style="display: none">
      <van-checkbox v-model="form.agree" shape="square">
        我已阅读并同意协议
      </van-checkbox>
      <van-button
        block
        class="mt10"
        :disabled="!form.agree"
        size="large"
        type="primary"
        @click="submit"
      >
        同意协议
      </van-button>
    </div>
    <transition name="fade">
      <div v-if="show && height > 0" class="sign flex" style="display: none">
        <div class="btn-box2 flex flex-v flex-pack-center">
          <van-button
            class="sign-show"
            style="display: none"
            type="danger"
            @click="cancelSign"
          >
            取消
          </van-button>
          <van-button
            class="sign-show"
            style="display: none"
            type="default"
            @click="resetSign"
          >
            重写
          </van-button>
          <van-button
            class="sign-show"
            style="display: none"
            type="primary"
            @click="createSign"
          >
            确定
          </van-button>
        </div>
        <div class="sign-bd">
          <vue-esign
            ref="esign"
            v-model:bgColor="bgColor"
            class="sign-content"
            :height="signHeight + 400"
            :is-crop="isCrop"
            :line-color="lineColor"
            :line-width="lineWidth"
            :width="width"
          />
        </div>
        <div class="sign-hd flex flex-v flex-pack-center flex-align-center">
          <div class="sign-show" style="display: none">请在空白处输入签名</div>
        </div>
      </div>
    </transition>
    <ReadFile ref="readFile" :popup-close="popupClose" />
    <AddPartA ref="addPartA" :data="partyA" />
  </div>
</template>
<script>
  export default {
    name: 'SignAgreement',
  }
</script>
<script setup>
  import AddPartA from './AddPartA.vue'
  import { useRouter, useRoute } from 'vue-router'
  import ReadFile from '@/components/ReadFile'
  import { Notify, Toast, Dialog } from 'vant'
  import ZyUpload from '@/components/ZyUploader'
  import store from '@/store'
  import { ref, onMounted, unref, nextTick, onBeforeUnmount } from 'vue'
  import { wxShare, dataURItoBlobv2, uploadFile, img2Base64 } from '@/utils'
  import wx from 'weixin-js-sdk'
  import { addErrorLog } from '@/utils/errorLog'
  //import html2canvas from 'html2canvas'
  import html2canvas from '@/utils/html2canvas'
  import { dateFormat } from '@/utils/filters'
  import '@/assets/scss/normalize.scss'
  import api from '@/api'
  import vueEsign from 'vue-esign'
  // import JsPDF from 'jspdf'

  const route = useRoute()
  const router = useRouter()
  const imgList = ref('')
  const tenant = ref({})
  const query = route.query
  const fromCase = query.fromCase
  // const FormId = query.FormId
  const ProdId = query.ProdId
  const loading = ref(false)
  const imgUrl = ref('')
  const time = ref(dateFormat(new Date(), 'yyyy年MM月dd日'))
  const userInfo = ref(store.getters['user/getUserInfo'])
  const width = ref(0)
  const height = ref(0)
  const agreement = ref(null)
  const agreementData = ref({})
  const form = ref({
    content: '',
    agree: true,
    AgreementId: '',
    agreeUrl: '',
    isAgreen: false,
    Process: null,
    UserInfo: null,
  })

  let todo = null
  const show = ref(false) // 显示签名
  const lineWidth = ref(6)
  const lineColor = ref('#000000')
  const bgColor = ref('#fff')
  const resultImg = ref('')
  const isCrop = ref(false)
  const readFile = ref(null)
  const esign = ref(null)
  const signHeight = ref(0)
  const AgreementInfo = ref({
    Sign: '',
    CorporateSealUrl: '',
    EnableCorporateSeal: false,
    EnableAgreementSign: false,
    EnableIdCard: false,
  })
  const intervalTime = ref('')

  /**
   * 弹出实名认证
   * @author hanson.liu
   * @date 2022-08-09
   * @returns {any}
   */
  const addPartA = ref(null)
  const partyA = ref({
    username: '',
    id: '',
    phone: '',
  })
  const showPartAAdd = () => {
    console.log(addPartA.value)
    addPartA.value.show()
  }
  const popupClose = () => {
    if (fromCase) {
      window.history.back()
    } else {
      router.back()
    }
  }
  const getAgreenment = () => {
    // loading.value = true
    wxShare('用户协议', '请认真阅读并同意协议')
    return store
      .dispatch('service/ProductAgreementGetAgreement', {
        productId: ProdId,
        // FormId,
      })
      .then(async (data) => {
        await GetAgreementInfo()
        form.value.AgreementId = data.Data.AgreementId
        form.value.content = data.Data.Content
        form.value.Title = data.Data.Title
        loading.value = false
      })
      .catch(async (e) => {
        const { Code } = e
        let msg = e.Message
        if (Code === 1005) {
          form.value.isAgreen = true
          form.value.agreeUrl = e.Message
          msg = '您已签署过协议！'
        }
        if (Code === 1004) {
          await GetAgreementInfo()
          form.value.isAgreen = true
          const Data = JSON.parse(e.Message)
          form.value.content = Data.Agreement.Content
          form.value.Process = Data.Process
          form.value.UserInfo = Data.UserInfo

          msg = '您已签署过协议！'
        }
        Dialog.alert({
          title: '温馨提示',
          message: msg || '出错了，请稍后再试',
          confirmButtonText: '知道了',
        }).then(() => {})
        loading.value = false
        console.log(e)
      })
  }
  onMounted(async () => {
    let nowTime = Date.now()
    let fiveminafter = nowTime + 5000
    await GetAgreementWithSignatureInfo()
    if (agreementData.value.IsSigned) {
      if (agreementData.value.AgreementAttachUrl) {
        loading.value = false
        readFile.value.readFile({
          MaterialName: '已签署的协议',
          MaterialUrl: agreementData.value.AgreementAttachUrl,
        })
      } else {
        intervalTime.value = setInterval(() => {
          let now = Date.now()
          if (now > fiveminafter) {
            loading.value = false
            clearInterval(intervalTime.value)
            Toast('正在生成，请稍后再试')
            if (fromCase) {
              window.history.back()
            } else {
              router.back()
            }
            return
          }
          GetAgreementWithSignatureInfo()
          if (agreementData.value.AgreementAttachUrl) {
            clearInterval(intervalTime.value)
            readFile.value.readFile({
              MaterialName: '已签署的协议',
              MaterialUrl: agreementData.value.AgreementAttachUrl,
            })
          }
        }, 500)
      }
    } else {
      await getAgreenment()
      width.value = document.body.offsetWidth
      height.value = document.body.offsetHeight
      signHeight.value = window.screen.height
      init()
    }
  })
  onBeforeUnmount(() => {
    if (intervalTime.value) {
      clearInterval(intervalTime.value)
    }
  })
  //查看是否签署协议
  const GetAgreementWithSignatureInfo = () => {
    loading.value = true
    const param = {
      productId: ProdId,
    }

    return store
      .dispatch('service/FormGetAgreementWithSignatureInfo', param)
      .then((data) => {
        const { Data } = data
        agreementData.value = Data
      })
      .catch((e) => {
        Toast.fail(e.Message || '获取协议信息失败')
      })
  }

  const init = async () => {
    tenant.value = await store.getters['user/getTenant']
    // 如果已经签署过则展示pdf
    if (form.value.isAgreen && form.value.agreeUrl) {
      readFile.value.readFile({
        MaterialName: '已签署的协议',
        MaterialUrl: form.value.agreeUrl,
      })
    }

    const imgList = Array.from(document.getElementsByTagName('img'))
    imgList.forEach(async (item) => {
      const base64 = await img2Base64(item)
      item.src = base64
    })
  }

  // 清空签名
  const resetSign = () => {
    esign.value.reset()
  }

  const cancelSign = () => {
    show.value = false
    todo = null
  }

  const createSign = () => {
    esign.value
      .generate()
      .then(async (res) => {
        const newImg = await drawImgToCanvas(res, -90)
        AgreementInfo.value.Sign = newImg
        show.value = false
        if (todo) {
          nextTick(() => {
            todo()
          })
        }
      })
      .catch((err) => {
        Toast('请输入签名')
      })
  }

  const drawImgToCanvas = (image, rotate) => {
    return new Promise((resolve, reject) => {
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      var img = new Image()
      img.setAttribute('crossOrigin', 'Anonymous')
      img.src = image

      img.onload = function () {
        canvas.width = img.height
        canvas.height = img.width

        context.translate(canvas.width / 2, canvas.height / 2)
        context.rotate((rotate * Math.PI) / 180)
        context.translate(-canvas.width / 2, -canvas.height / 2)
        context.drawImage(
          img,
          canvas.width / 2 - img.width / 2,
          canvas.height / 2 - img.height / 2
        )
        context.translate(canvas.width / 2, canvas.height / 2)
        context.rotate((-rotate * Math.PI) / 180)
        context.translate(-canvas.width / 2, -canvas.height / 2)
        context.restore()
        var base64 = canvas.toDataURL('image/png', 0.9)
        //testImg.src = base64
        resolve(base64)
        //console.log('base64', base64)
      }
    })
  }

  // 获取是否需要手写签名
  const GetAgreementInfo = async () => {
    const tenant = await store.getters['user/getTenant']
    return store
      .dispatch('service/GetAgreementInfo', {
        tenantId: tenant.TenantId,
      })
      .then((data) => {
        const { Data } = data
        Object.assign(AgreementInfo.value, Data)
      })
  }

  const gethtml = async () => {
    //window.document.head.innerHTML,
    let html = `<!DOCTYPE html>
      <html>
      <head>
      <style>
      .ql-editor{line-height:1.42;}
      .ql-editor .ql-size-small{font-size:0.75em}
      .ql-editor .ql-size-large{font-size:1.5em}
      .ql-editor .ql-size-huge{font-size:2.5em}
      .ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}
      .ql-editor .ql-align-center{text-align:center}
      .ql-editor .ql-align-justify{text-align:justify}
      .ql-editor .ql-align-right{text-align:right}
      .ql-snow a {color: #06c;}
      </style>
      </head>
      <body>
      ${window.document.body.innerHTML}
      </body>
      </html>`

    // fs.readFile('@/assets/scss/normalize.scss', 'utf-8', function (err, data) {
    //   if (err) {
    //     console.log(err)
    //   } else {
    //     console.log(data)
    //   }
    // })

    //let html = temp.join('')
    const h5url = await store.getters['system/getH5Url']
    html = html.replace(/<link href="css/g, `<link href="${h5url}survey/css`)
    html = html.replace(/请先阅读并同意协议/g, ``)
    html = html.replace(/请先阅读协议并签名/g, ``)
    html = html.replace(/腾宇一号提供技术支持/g, ``)
    return html
  }

  const submit = async () => {
    // console.log('lalal', AgreementInfo.value.EnableIdCard)
    if (AgreementInfo.value.EnableIdCard) {
      if (!partyA.value.id) {
        Toast('请先进行实名认证')
        return
      }
    }
    if (!form.value.agree) {
      Toast('请先阅读并同意协议')
      return
    }
    if (AgreementInfo.value.EnableAgreementSign && !AgreementInfo.value.Sign) {
      Toast('请先阅读协议并签名')
      todo = submit
      show.value = true
      return
    }
    todo = null
    try {
      const toast = Toast.loading({
        message: '正在提交...',
        forbidClick: false,
        duration: 0,
        loadingType: 'spinner',
      })
      const html = await gethtml()
      agree(html)
      return
      //获取协议图片
      // const img = await getPdf()
      // const url = img.toDataURL('image/jpeg', 0.5)
      // const bold = dataURItoBlobv2(url, '协议内容.jpeg')
      // await uploadFile(bold)
      //   .then((data) => {
      //     const { Data } = data.data
      //     agree(Data)
      //   })
      //   .catch((e) => {
      //     // 就算是上传失败也不能影响协议的签署
      //     agree('', '，但是上传协议截图失败了')
      //     addErrorLog(
      //       {
      //         level: 3,
      //         message: '用户同意了协议，但是上传协议截图失败了',
      //       },
      //       null,
      //       'info'
      //     )
      //   })
      //同意协议
    } catch (error) {
      // 就算是上传失败也不能影响协议的签署
      agree('', '，但是生成协议截图失败了')
      addErrorLog(
        {
          level: 3,
          message: '用户同意了协议，但是生成协议截图失败了' + error,
        },
        null,
        'info'
      )
    }
  }

  const agree = (html, msg = '') => {
    return store
      .dispatch('service/FormSignAgreement', {
        Pass: true,
        Remark: '用户同意了协议' + msg,
        Screenshot: imgList.value,
        Recording: '',
        productId: ProdId,
        AgreementId: form.value.AgreementId,
        //AgreementAttachUrl: html,
        HtmlContent: html,
        username: partyA.value.username,
        identityNumber: partyA.value.id,
        phone: partyA.value.phone,
      })
      .then((data) => {
        const { Code, Message } = data
        if (Code === 0) {
          // 用于小程序webview
          if (query.from === 'mp') {
            Toast.success('提交成功，请点击右上角返回')
            return
          }
          Toast.success('提交成功！')
          setTimeout(() => {
            Toast.clear()
            if (fromCase) {
              window.history.back()
            } else {
              router.back()
            }
          }, 2000)
        } else {
          let msg = Message || '提交失败'
          Toast.fail(msg)
        }
      })
      .catch((e) => {
        let msg = e.Message || '提交失败'
        if (e.Code === 2001) {
          msg = '用户协议需本人签署'
        }
        Toast.fail(msg)
        setTimeout(() => {
          Toast.clear()
        }, 3000)
      })
  }

  const getPdf = async () => {
    var realHtml = document.getElementById('agreement-bd') //需要截图的包裹的（原生的）DOM 对象
    var width = realHtml.offsetWidth //获取dom 宽度
    var height = realHtml.offsetHeight //获取dom 高度
    var canvas = document.createElement('canvas') //创建一个canvas节点
    var scale = 1 //定义任意放大倍数 支持小数
    canvas.width = width * scale //定义canvas 宽度 * 缩放
    canvas.height = height * scale //定义canvas高度 * 缩放
    canvas.getContext('2d').scale(scale, scale) //获取context,设置scale
    var opts = {
      width: parseInt(window.getComputedStyle(realHtml).width),
      height: parseInt(window.getComputedStyle(realHtml).height),
      allowTaint: true,
      useCORS: true,
      taintTest: true, //检测每张图片都已经加载完成
      scale: 1, // window.devicePixelRatio, // 设备像素比
      dpi: 120,
      ignoreElements: (element) => {
        // 可从渲染中删除匹配的元素
        if (element.className === 'exclude') return true
      },
    }

    return (window.html2canvas || html2canvas)(realHtml, opts)
  }
</script>
<style lang="scss" scoped>
  .agreement {
    padding: 10px 12px 40px;
    .ql-editor {
      padding: 0 !important;
    }
    .Corporate-img {
    }
    .sign-btn {
      // padding: 2px 5px;
      // color: #1989fa;
    }
    .sign-img {
      // width: 50px;
      // display: block;
      // transform: rotate(-90deg);
      // transform-origin: 30% 30%;
    }
    // .canvas-img {
    //   background-color: #ffff00;
    //   width: 50%;
    //   height: 200%;
    //   transform: rotate(-90deg);
    //   transform-origin: 30px 30px;
    // }
  }
  .btn-box {
    display: block !important;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 16px;
    background: #fff;
  }
  .mt10 {
    margin-top: 12px;
  }
  .sign {
    display: flex !important;
    position: fixed;
    background: #fff;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    .sign-hd {
      background: #f0f0f0;
      width: 50px;
      line-height: 1;
      > div {
        width: 160px;
        transform: rotate(90deg);
      }
    }
    .btn-box2 {
      width: 70px;
      height: 100%;
      background: #f0f0f0;
      button {
        transform: rotate(90deg);
        padding: 0;
        width: 100px;
        margin: 50px -15px;
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0; /*透明度*/
    transform: translateX(-50%);
  }
  .sign-show {
    display: block !important;
  }
  .sign-content {
    display: block !important;
    height: 100%;
  }
  .add-parta {
    display: block !important;
    position: absolute;
    top: 50%;
    margin-top: -18px;
    left: 100px;
  }
</style>
